import {i18n} from "@packages/I18n";

export default function nodeType(value) {
    return {
        LOCAL: i18n.t('message.spots.message.spot'),
        GRUPO_LOCAL: i18n.t('message.spots.message.spotsGroup'),
        APARELHO: i18n.t('message.spots.message.device'),
        GRUPO_PONTO_ACESSO: i18n.t('message.spots.message.accessPointGroup')
    }[value];
}
